// Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Import the auth context
import Swal from 'sweetalert2'; // Import SweetAlert2
import axios from 'axios'; // Import Axios for API calls
import './login.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth(); // Get login function from context
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Create the data object to send
    const data = {
      username, // Assuming the API expects 'email' instead of 'username'
      password
    };
  
    // Define the headers (add your actual headers here)
    const headers = {
      'x-api-key': API_KEY, // Example of adding an authorization header
      'Content-Type': 'application/json',
    };
  
    try {
  
      const response = await axios.post(API_BASE_URL, // Replace with your actual API endpoint
        data, // The data to send with the request
        { headers } // Include headers here
      );
  
  
      if (response.status === 200) {  // Check if the status code is 200
        setError('');
        Swal.fire({
          title: 'Success!',
          text: 'Login successful!',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          login(); // Set the user as authenticated
          navigate('/dashboard'); // Redirect to dashboard after successful login
        });
      }
    } catch (error) {
      setError('An error occurred while logging in');
      Swal.fire({
        title: 'Error!',
        text: 'An error occurred while logging in. Please try again.',
        icon: 'error',
        confirmButtonText: 'Try Again',
      });
    }
  };
  

  return (
    <div className="login-container">
      <h2 className="login-title">Login</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-container">
          <label className="input-label">Username</label>
          <input 
            type="text" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            className="input-field"
            required 
          />
        </div>
        <div className="input-container">
          <label className="input-label">Password</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            className="input-field"
            required 
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="login-button">
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
